import { FunctionComponent } from 'react'
import styled from 'styled-components'
import Media from 'components/utils/Media'

import {
  ExploreRegionQueryResult,
  useGetBucketListItemsIndexQuery,
} from '../../../hooks/useQueries'
import { breakpoints, media } from '../../../styles/media'

import Container from '../../../components/layout/Container'
import ButtonRouterLink from '../../../components/display/ButtonRouterLink'
import { HorizontalListTrack } from '../../../components/display/HorizontalList'
import StoryCard from '../../../components/cards/StoryCard'
import WithSelectEscape from '../../../components/SelectEscape/WithSelectEscape'

import Adventures from './Adventures'

const AdventuresWrapper = styled.section`
  margin-top: 8px;
  margin-bottom: 40px;
`

const StoryListWrapper = styled.div`
  ${media.md`
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
  `}
`

const StoriesList = styled.div`
  padding: 0 16px;

  ${media.md`
    display: flex;
    flex-wrap: wrap;

    margin: 0 -16px;
  `}
`

const StoriesListItem = styled.div`
  width: 100%;

  ${media.md`
    width: 50%;
    padding: 0 16px;
  `}

  ${media.lg`
    width: 33.333%;
    max-width: 416px;
  `}
`

const ExploreButton = styled(ButtonRouterLink).attrs({
  ghost: true,
  fullwidth: true,
})`
  display: block !important;
  max-width: 416px !important;
  margin: 0 auto;
  text-transform: uppercase;
`

type ExploreRegionNode = ExploreRegionQueryResult['data']['explore']['region']

type ExploreSectionProps = ExploreRegionNode & {
  countryCode: GQL_Countries
  state: {
    code: string
  }
}

const ExploreSection: FunctionComponent<ExploreSectionProps> = ({
  id,
  countryCode,
  state,
  slug,
  name,
  stories,
}) => {
  const {
    data: bucketListIndexData,
    loading: bucketListIndexLoading,
  } = useGetBucketListItemsIndexQuery({
    fetchPolicy: 'cache-first',
  })

  const bucketListItemsIndex = bucketListIndexData?.currentUser
    ?.bucketListItemsIndex as GQL_BucketListItemsIndex

  return (
    <div>
      <StoryListWrapper>
        <Media query={`(min-width: ${breakpoints.lg}px)`}>
          {(isLg: boolean) => {
            return (
              <HorizontalListTrack>
                <StoriesList>
                  {!bucketListIndexLoading &&
                    stories.map((story) => {
                      return (
                        <StoriesListItem key={story.id}>
                          <WithSelectEscape
                            itemId={story.id}
                            itemType="Story"
                            bucketListItemsIndex={bucketListItemsIndex}
                          >
                            <StoryCard
                              story={story}
                              listing={story.featuredListing}
                              sameTab={!isLg}
                            />
                          </WithSelectEscape>
                        </StoriesListItem>
                      )
                    })}
                </StoriesList>
              </HorizontalListTrack>
            )
          }}
        </Media>

        <AdventuresWrapper>
          <Adventures regionId={id} />
        </AdventuresWrapper>
      </StoryListWrapper>

      <Container>
        <ExploreButton
          to={`/listings?type=accommodation&country=${countryCode}&state=${state.code}&regions[]=${slug}`}
        >
          All {name}
        </ExploreButton>
      </Container>
    </div>
  )
}

export default ExploreSection
